
import { API_GET, API_POST } from "../../services/api.service";
import { getCookie } from "../../services/Common";
import { WHATSAPP_SERVER } from "../../variables/general";

export const getConnectedDevice = async ({admin,username}) =>{
    const postData = {data: {admin,username}, url : "user/getConnectedDevice" };
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const defaultWhatsappDevice = async () =>{
    
    try{
        const user = getCookie("whatsappDefaultDevice");
        const jsond = JSON.parse(user);
        console.log("user................",jsond);
        return jsond;
    }catch(e){
    return {};
    }
}

export const updateTemplate = async (params) =>{

}

export const connectNewDevice = async (params) =>{
    const postData = {data: params, url : "user/connect" };
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const getAutoReply = async ({admin,username}) =>{
    const postData = {data: {admin,username}, url : "autoReply/getList" };
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const getTemplates = async (params) =>{
    const {userId,token} = getUser();
    const postData = {data: params, url : "templates/getList",headers: {connectDeviceId:userId,token} };
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const getLogs = async (params) =>{
    const {userId,token} = getUser();
    const postData = {data: params, url : "user/logs" ,headers: {connectDeviceId:userId,token}};
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const addAutoreply = async (params) =>{
    console.log(params);
    const {userId,token} = getUser();
    const postData = {data: params, url : "autoReply/create" ,headers: {connectDeviceId:userId,token}};
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const getPhoneList = async (params) =>{
    console.log(params);
    const {userId,token} = getUser();
    const postData = {data: params, url : "message/getPhoneList" ,headers: {connectDeviceId:userId,token}};
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const getMessagesList = async (params) =>{
    console.log(params);
    const {userId,token} = getUser();
    const postData = {data: params, url : "message/getMessages" ,headers: {connectDeviceId:userId,token}};
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}


export const sendMessage = async (params) =>{
    console.log(params);
    const {userId,token} = getUser();
    const postData = {data: params, url : "message/send" ,headers: {connectDeviceId:userId,token}};
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const sendTemplateMessage = async (params) =>{
    console.log(params);
    const {userId,token} = getUser();
    const postData = {data: params, url : "message/template" ,headers: {connectDeviceId:userId,token}};
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}


export const createTemplate = async (params) =>{
    console.log(params);
    const {userId,token} = getUser();
    const postData = {data: params, url : "templates/create" ,headers: {connectDeviceId:userId,token}};
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const deleteDevices = async (params) =>{
    console.log(params);
    const {userId,token} = getUser();
    const postData = {data: params, url : "user/delete" ,headers: {connectDeviceId:userId,token}};
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const setDefault = async (params) =>{
    console.log(params);
    const {userId,token} = getUser();
    const postData = {data: params, url : "user/setDefault" ,headers: {connectDeviceId:userId,token}};
    let userInfo = await API_POST(`whatsapp/sendRequest`,postData);
    return userInfo.data;
}

export const getWhatsappUserToken = async ()=>{
    const {userId,token} = getUser();
    return {userId,token};
}

const encryptObject = (obj, key) => {
    const jsonString = JSON.stringify(obj);
    return btoa(
      [...jsonString].map(char => 
        String.fromCharCode(char.charCodeAt(0) ^ key)
      ).join('')
    );
}

export const getWhatsappEncryptedTextUrl = async (testObj) =>{

    return await encryptObject(testObj, 42);

}

export const  getUser = () =>{
    try{
        const user = getCookie("metaWhatsapp");
        const jsond = JSON.parse(user);
        console.log("user................",jsond);
        return jsond;
    }catch(e){
    return {};
    }
}


export const getWhatsappUserDetails = async () =>{
    const user = getUser();
    return user;
}